"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DojoGauge = void 0;
const DojoGaugeCondition_1 = require("./lib/DojoGaugeCondition");
const DojoGaugeScope_1 = require("./lib/DojoGaugeScope");
/**
 * A single gauge that is required towards clearing a dojo course.
 */
class DojoGauge {
    constructor(condition, redClearRequirement, goldClearRequirement, scope) {
        this.condition = condition;
        this.redClearRequirement = redClearRequirement;
        this.goldClearRequirement = goldClearRequirement;
        this.scope = scope;
    }
    static parse(raw, strict = true) {
        const components = raw.split(',').map((c) => c.trim());
        if (components.length !== 4) {
            if (strict) {
                throw new Error(`Invalid gauge value: ${raw}`);
            }
            return undefined;
        }
        const condition = DojoGaugeCondition_1.DojoGaugeCondition.fromRaw(components[0]);
        const redClearRequirement = parseInt(components[1], 10);
        const goldClearRequirement = parseInt(components[2], 10);
        const scope = DojoGaugeScope_1.DojoGaugeScope.fromRaw(components[3]);
        if (!condition ||
            isNaN(redClearRequirement) ||
            isNaN(goldClearRequirement) ||
            !scope) {
            if (strict) {
                throw new Error(`Invalid gauge value: ${raw}`);
            }
        }
        return new DojoGauge(condition, redClearRequirement, goldClearRequirement, scope);
    }
    toString() {
        return `${this.condition},${this.redClearRequirement},${this.goldClearRequirement},${this.scope}`;
    }
}
exports.DojoGauge = DojoGauge;
